import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NovoChamadoFormProvider } from 'src/app/providers';
import { ICardComponentData, IUsuario } from 'src/app/interfaces';
import { IToken } from 'src/app/interfaces/token/IToken';
import {
  AuthenticationService,
  EquipamentoService,
  UsuarioService
} from 'src/app/services';

@Component({
  selector: 'app-abrir-chamado-b',
  templateUrl: './abrir-chamado-b.component.html',
  styleUrls: ['./abrir-chamado-b.component.scss']
})
export class AbrirChamadoBComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  token: IToken = this.authenticationService.obterToken();
  usuario: IUsuario;
  cardData: ICardComponentData[] = [];
  form: FormGroup;
  formPrimeiroPasso: FormGroup;

  constructor(
    private equipamentoService: EquipamentoService,
    private novoChamadoFormProvider: NovoChamadoFormProvider,
    private router: Router,
    private location: Location,
    private authenticationService: AuthenticationService,
    private usuarioService: UsuarioService
  ) {}

  montarCard(data) {
    this.cardData = [
      { title: 'Cliente', value: data?.nomeCliente },
      { title: 'N° de Série', value: data?.numSerie },
      { title: 'Marca', value: data?.nomeMarcaProduto },
      { title: 'Modelo', value: data?.modelo },
      { title: 'N° de Patrimônio', value: data?.numPat },
      { title: 'Código de Contrato', value: data?.codigoContr }
    ];
  }
  getDetalheEquipamento() {
    this.subscriptions$.add(
      this.equipamentoService
        .getEquipamentos({
          idUsuario: this.token.id,
          CodSite: this.formPrimeiroPasso.get('equipamento')?.value.codSite,
          codContrato: [
            this.formPrimeiroPasso.get('equipamento')?.value.codigoContr
          ],
          numserie: this.formPrimeiroPasso.get('equipamento')?.value.numSerie,
          TipoUsuario: this.token.tipoUsuario,
          paginar: false
        })
        .subscribe(({ data }) => {
          this.montarCard(data.registros[0]);
        })
    );
  }

  prosseguir() {
    this.router.navigate(['equipamento/abrir-chamado/3'], {
      queryParams: { cardData: JSON.stringify(this.cardData) }
    });
  }

  ngOnInit(): void {
    this.getUsuarioId();
    const primeiroPassoInvalido = this.novoChamadoFormProvider
      .getForm()
      .get('primeiroPasso')?.valid;
    if (!primeiroPassoInvalido) {
      this.location.back();
      return;
    }

    this.formPrimeiroPasso = this.novoChamadoFormProvider
      .getForm()
      .get('primeiroPasso') as FormGroup;

    this.form = this.novoChamadoFormProvider
      .getForm()
      .get('segundoPasso') as FormGroup;

    this.getDetalheEquipamento();
  }

  preencherFormUsuario(checked: boolean) {
    if (checked) {
      if (this.usuario.celular === null && this.usuario.telefone === null) {
        this.form.setValue({
          ...this.form.getRawValue(),
          contato: this.usuario.nome
        });
        this.form.get('contato')?.disable();
        return;
      }
      if (this.usuario.celular !== '' && this.usuario.telefone !== '') {
        this.form.setValue({
          ...this.form.getRawValue(),
          contato: this.usuario.nome,
          celular: this.usuario.celular,
          fone: this.usuario.telefone
        });
        this.form.get('contato')?.disable();
        this.form.get('celular')?.disable();
        this.form.get('fone')?.disable();
        return;
      }
      if (this.usuario.celular !== '' && this.usuario.telefone === '') {
        this.form.setValue({
          ...this.form.getRawValue(),
          contato: this.usuario.nome,
          celular: this.usuario.celular
        });
        this.form.get('contato')?.disable();
        this.form.get('celular')?.disable();
        return;
      }
      if (this.usuario.celular === '' && this.usuario.telefone !== '') {
        this.form.setValue({
          ...this.form.getRawValue(),
          contato: this.usuario.nome,
          fone: this.usuario.telefone
        });
        this.form.get('contato')?.disable();
        this.form.get('fone')?.disable();
        return;
      }
    }
    this.form.enable();
  }

  getUsuarioId() {
    this.subscriptions$.add(
      this.usuarioService
        .getUsuario({
          idUsuario: this.token.id,
          usuarioId: this.token.id,
          paginar: false
        })
        .subscribe({
          next: ({ data }) => {
            this.usuario = data.registros[0];
          }
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
